export let imageData = {
	altText: 'Image',
};
